export default "https://cdn-static.gokick.com/assets/8bc125c24491fd75c87852671f08945500f37a20/images/choco-chill.d2e5a3cb4eac031c8a1d2dbef046a05a.png";